const InProgressIcon = () => (
  <svg
    className="w-5 h-5"
    fill="#3f83f8"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="icon-status"
  >
    <path
      fillRule="evenodd"
      d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
      clipRule="evenodd"
    />
  </svg>
);
export default InProgressIcon;
